export default function PageLoader() {
  return (
    <div className="bg-background flex h-screen w-full items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="border-primary h-12 w-12 animate-spin rounded-full border-4 border-t-transparent" />
        <span className="text-muted-foreground text-sm font-medium">Loading...</span>
      </div>
    </div>
  );
}
